import { render, staticRenderFns } from "./Spirit.vue?vue&type=template&id=529aaf82&scoped=true"
import script from "./Spirit.vue?vue&type=script&lang=js"
export * from "./Spirit.vue?vue&type=script&lang=js"
import style0 from "./Spirit.vue?vue&type=style&index=0&id=529aaf82&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529aaf82",
  null
  
)

export default component.exports